// extracted by mini-css-extract-plugin
export default {"fields":"Fwn1Dw","gaps":"RxU_5z","time":"akqxwB","mobile":"TlBTpR"};